import React from 'react';
import { getSettingFromHtml } from '../common';

const ChinaMediaError = () => {

    const chinaMediaErr = getSettingFromHtml('china-media-msg') || '';

    return (
        <div className="error-box">{ chinaMediaErr }</div>
    )
};

export default ChinaMediaError;